import axios from "axios";
import { apiURL } from "../config/default";
import setAuthHeader from "../utils/setAuthHeader";

export const getAddressBook = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.get(`${apiURL}address-books`);
    return res.data;
  } catch (err) {
    console.log(err.response.data.error);
  }
};

export const retreive = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.get(`${apiURL}address-book/${id}`, _config);
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;

    console.log(errors);
  }
};

export const addAddressBook = (formData) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.post(
      `${apiURL}create-address-book`,
      formData,
      _config
    );
    return res.data;
  } catch (err) {
    console.log(err.response.data.error);
  }
};

export const editAddressBook = (formData) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.post(
      `${apiURL}edit-address-book`,
      formData,
      _config
    );
    return res.data;
  } catch (err) {
    console.log(err.response.data.error);
  }
};

export const deleteAddressbook = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.get(`${apiURL}delete-address-book/${id}`);
    return res.data;
  } catch (err) {
    console.log(err.response.data.error);
  }
};
